<!-- Copyright 2019, Nathan Lecompte -->

<template>
    <div class="i-res-item" @click="scrollTo(item.id)" v-if="item.img.src">
        <img :id="item.id" :src="item.img.srcThumb" :alt="item.title" :title="item.title" loading="lazy"/>
        <div class="i-res-info">
            <h2 :title="item.title">{{ item.title }}</h2>
            <a :href="item.url" tabindex="0" title="Visit source">Visit</a>
            <a :href="item.img.src" tabindex="0" title="View file">View</a>
            <p>{{ item.engine }}</p>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        item: {
            type: Object,
            required: true
        }
	},
    methods: {
        // Function to scroll to image result item
        scrollTo(id) {
            document.getElementById(id).scrollIntoView({ 
                behavior: "smooth", 
                block: "center", 
                inline: "center" 
            })
        }
    }
}
</script>

<style>
/* Image search results */
.i-res {
	display: flex;
	counter-reset: brick 0;
	margin-top: -4px;
	flex-flow: row wrap
}

/* Image result */
.i-res-item {
	position: relative;
	display: block;
	align-content: center;
	min-height: 20vh;
	margin: 4px;
	text-align: left;
	font-weight: 600;
	flex: auto;
	cursor: pointer;
	overflow: hidden;
	border-radius: 2px;
	outline: none;
	-webkit-tap-highlight-color: transparent;
	box-shadow: 0 1px 2px rgba(var(--primaryColor), .025), inset 0 0 0 1px rgba(var(--primaryColor), .05);
	transition: var(--animationSpeed) ease;
	z-index: 1
}
.i-res-item img {
	width: calc(100% - 2px);
	width: calc(100% - 2px);
	max-height: 20vh;
	border-radius: 2px;
	object-fit: cover;
	margin: 1px;
	transition: var(--animationSpeed) ease;
	z-index: 1
}
.i-res-item:active,
.i-res-item:focus {
	transform: scale(.98)
}

/* Image result > Info */
.i-res-info {
	display: block;
	position: relative;
	margin: -98px -1px 0 0;
	height: 90px;
	opacity: 0;
	border-radius: 0 0 2px 2px;
	transform: translateY(50%) scale(1,.5);
	background: linear-gradient(transparent, black);
	transition: var(--animationSpeed) ease;
	z-index: -1
}
.i-res-item:hover .i-res-info, 
.i-res-item:active .i-res-info,
.i-res-item:focus .i-res-info,
.i-res-item:focus-within .i-res-info {
	transform: translateY(0) scale(1);
	opacity: 1;
	z-index: 2
}
.i-res-info h2, .i-res-info p {
	position: absolute;
	margin: 0;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis
}
.i-res-info h2 {
	top: 14px;
	left: 18px;
	right: 18px;
	font-size: 1em;
	font-weight: 600;
	text-shadow: 0 1px 1px rgba(0, 0, 0, .25);
	color: #fff
}
.i-res-info a {
	display: block;
	float: left;
	margin: 40px 0 0 10px;
	padding: 10px;
	font-size: .9em;
	text-decoration: none;
	color: #fff;
	-webkit-tap-highlight-color: transparent;
	transition: var(--animationSpeed) ease
}
.i-res-info a:active,
.i-res-info a:focus {
	background: rgba(255, 255, 255, .15);
	border-radius: 2px
}
.i-res-info p {
	top: 50px;
	right: 18px;
	width: calc(100% - 150px);
	color: rgba(255, 255, 255, var(--primaryOpacity));
	font-size: .9em;
	font-weight: 400;
	text-align: right
}

/* Media queries (mobile/responsive) */
@media (max-width: 600px) {
	.i-res {
		margin: -4px 20px 20px
	}
	.i-res-item img {
		max-height: 30vh
	}
}
@media (max-width: 400px) {
	.i-res .res-suggestions {
		margin: 0 -20px 20px
	}
}
</style>